import { Component, OnInit } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'app-news-update-table-tooltipcelheader-isexpried',
  templateUrl: './news-update-table-tooltipcelheader-isexpried.component.html',
  styleUrls: ['./news-update-table-tooltipcelheader-isexpried.component.scss']
})
export class NewsUpdateTableTooltipcelheaderIsexpriedComponent implements IHeaderAngularComp {

  public status: string;
  public ascSort: string;
  public descSort: string;
  public params: any;
  tooltipOptions: Object;
  constructor() { }
  refresh(params: IHeaderParams): boolean {
    return true
  }
  agInit(params: IHeaderParams): void {
    this.status = params.displayName;
    this.params = params;
    params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
    this.onSortChanged();
  }
  onSortChanged() {
    this.ascSort = this.descSort = 'inactive';
    if (this.params.column.isSortAscending()) {
      this.ascSort = 'active';
    } else if (this.params.column.isSortDescending()) {
      this.descSort = 'active';
    }
  }

  onSortRequested(order, event) {
    if (order === 'asc') {
      document.getElementById('descId').style.display = 'block';
      document.getElementById('descId').style.color = '#e9b10c';
      document.getElementById('ascId').style.display = 'none';
      document.getElementById('initialId').style.display = 'none';
    }
    else if (order === 'desc') {
      document.getElementById('descId').style.display = 'none';
      document.getElementById('ascId').style.display = 'none';
      document.getElementById('initialId').style.display = 'block';
    }
    this.params.setSort(order, event.shiftKey);
  }
  initialSort() {
    document.getElementById('ascId').style.display = 'block';
    document.getElementById('descId').style.display = 'none';
    document.getElementById('initialId').style.display = 'none';
    document.getElementById('ascId').style.color = '#e9b10c';
  }

}
